export default __webpack_public_path__ + "static/media/icon-twitter.93adbbbd.svg";